module.exports = __webpack_public_path__ + "img/数据管理.868c2d5c.jpg";